var path = 'areas/projects/actions/azure_powershell/Octopus.AzurePowerShell_summary.html';
var html = "<p> Run a PowerShell script using an Azure subscription with Azure modules loaded <span ng-show='properties[\"Octopus.Action.TargetRoles\"] && isSingleStep'>on behalf of targets in roles: <tag-list tags='properties[\"Octopus.Action.TargetRoles\"]'></tag-list></span> </p> ";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./app/areas/projects/actions/azure_powershell/Octopus.AzurePowerShell_summary.html
// module id = 2760714690096078
// module chunks = 1